import { httpClient } from './axiosClients';

export function getIsAuthenticated() {
  return httpClient.get('/api/wc/is-authenticated');
}

export function getCities({ params }) {
  return httpClient.get('/api/city', { params });
}
